import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { MdOutlineDarkMode } from "react-icons/md";
import { Sun } from "lucide-react";
import { cn } from "@/lib/utils";
import { setTheme } from "@/redux/reducers/ThemeReducer"; // adjust the path if needed
import { Button } from "@/components/ui/Button";

const ThemeToggleButton = () => {
  const dispatch = useDispatch();
  const currentTheme = useSelector((state) => state.theme.theme); // assuming your slice is named 'theme'

  // Toggle between 'light' and 'dark'
  const handleThemeChange = () => {
    const themeName = currentTheme === "dark" ? "light" : "dark";

    dispatch(setTheme(themeName));
  };

  const isDark = currentTheme === "dark";

  return (
    <Button className="liquid-toggle relative flex items-center w-[57px] h-[30px] p-[5px] rounded-[18px] transition-all duration-300" onClick={handleThemeChange}>
      <span className={cn("liquid-knob flex items-center justify-center", isDark ? "translate-x-[2px]" : "translate-x-[24px]")}>
        {isDark ? <MdOutlineDarkMode size={14} className="icon-glow" /> : <Sun size={14} className="icon-glow" />}
      </span>
    </Button>
  );
};

export default ThemeToggleButton;
